import { render, staticRenderFns } from "./ReviewHome.vue?vue&type=template&id=2c6cb949&scoped=true"
import script from "./ReviewHome.vue?vue&type=script&lang=js"
export * from "./ReviewHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cb949",
  null
  
)

export default component.exports